<template>
    <div>
        <navBar />
        <NetworkConnction v-if="checkInt" />
       <loading v-if="isLoading"/>
        <slot></slot>
        <!-- <div class="icon-sticky">
         <img src="~/assets/imgs/whatsApp.svg" alt="">
        </div> -->
        <div class="icon-sticky" :class="{'active':activeIcon}">
      <a  aria-label="whats-app" target="_blank" :href="store2.social?.whatsapp ? store2.social?.whatsapp : 'https://api.whatsapp.com/send?phone=' + store2.websiteData?.phone" class="whats-app-icon">
        <client-only>
          <Vue3Lottie :animation-data="whatsappIcon" :height="70" :width="70" />
        </client-only>
      </a>
    </div>
       </div>
        <mainFooter />
</template>



<script setup>
import { useContactStore } from "@/stores/contact";
import { useHomeStore } from "@/stores/home";
import { useCareerStore } from "@/stores/career";
import { Vue3Lottie } from "vue3-lottie";

import whatsappIcon from "~/assets/animations/whatsapp.json";

let store3 = useCareerStore();
let store = useContactStore();
 let store2 = useHomeStore();
const isLoading = ref(true);
const checkInt = ref(false);
const { locale, setLocale } = useI18n();

const handleOffline = () => {
  checkInt.value = true;
};
const handleOnline = () => {
  checkInt.value = false;
};


let activeIcon = ref(false);


onMounted(() => {
    isLoading.value = false;
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    window.addEventListener("scroll", function () {
    if (this.window.scrollY >= 200) {
      activeIcon.value = true;
    } else if (window.scrollY == 0) {
      activeIcon.value = false;
    }
  });
    useHead({
      htmlAttrs: {
        lang: locale.value == 'en' ? "en" : "ar",
        dir: locale.value == "en" ? "ltr" : "rtl",
      },
    });

});

onBeforeMount(() => {
  useHead({
      htmlAttrs: {
        lang: locale.value == 'en' ? "en" : "ar",
        dir: locale.value == "en" ? "ltr" : "rtl",
      },
    });
});

watch(
  [() => locale.value],
  ([val]) => {
    store.questions = [];
    store.page = 1;
    store3.careers = [];
    store3.page = 1;
    useHead({
      htmlAttrs: {
        lang: val == 'en' ? "en" : "ar",
        dir: val == "en" ? "ltr" : "rtl",
      },
    });
  }
);
onUnmounted(() => {
  window.removeEventListener('online', handleOnline);
  window.removeEventListener('offline', handleOffline);
  
});
</script>


<style>

</style>